<div class="cx-review">
  <!-- TITLE -->
  <h3 class="cx-review-title d-none d-lg-block d-xl-block">
    {{ 'checkoutReview.review' | cxTranslate }}
  </h3>
  @if ((steps$ | async).slice(0, -1); as steps) {
    <div class="cx-review-summary row">
      <ng-container>
        <div class="col-md-12 col-lg-6 col-xl-6 cx-review-payment-col">
          @for (step of paymentSteps(steps); track step) {
            @switch (step.type[0]) {
              @case (steps.PAYMENT_TYPE) {
                <ng-container *ngTemplateOutlet="poNumber"></ng-container>
              }
              @case (steps.PAYMENT_TYPE) {
                <ng-container *ngTemplateOutlet="paymentType"></ng-container>
              }
              @case (steps.PAYMENT_DETAILS) {
                <ng-container *ngTemplateOutlet="paymentMethod"></ng-container>
              }
              @case (steps.DELIVERY_ADDRESS) {
                <!-- <ng-container *ngTemplateOutlet="costCenter"></ng-container> -->
              }
            }
          }
        </div>
        <div class="col-md-12 col-lg-6 col-xl-6 cx-review-shipping-col">
          @for (step of deliverySteps(steps); track step) {
            @switch (step.type[0]) {
              @case (steps.DELIVERY_ADDRESS) {
                <ng-container *ngTemplateOutlet="shippingAddress"></ng-container>
              }
              @case (steps.DELIVERY_MODE) {
                <ng-container *ngTemplateOutlet="deliveryMode"></ng-container>
              }
            }
          }
        </div>
      </ng-container>
    </div>
    <!-- PO NUMBER SECTION -->
    <ng-template #poNumber>
      <div class="cx-review-summary-card">
        <cx-card [content]="getPoNumberCard(poNumber$ | async) | async"></cx-card>
        <div class="cx-review-summary-edit-step">
          <a
            [routerLink]="
              {
                cxRoute: getCheckoutStepUrl(steps.PAYMENT_TYPE)
              } | cxUrl
            "
            ><cx-icon [type]="iconTypes.PENCIL"></cx-icon
          ></a>
        </div>
      </div>
    </ng-template>
    <!-- PAYMENT TYPE SECTION -->
    <ng-template #paymentType>
      <div class="cx-review-summary-card">
        <cx-card [content]="getPaymentTypeCard(paymentType$ | async) | async"></cx-card>
        <div class="cx-review-summary-edit-step">
          <a
            [routerLink]="
              {
                cxRoute: getCheckoutStepUrl(steps.PAYMENT_TYPE)
              } | cxUrl
            "
            ><cx-icon [type]="iconTypes.PENCIL"></cx-icon
          ></a>
        </div>
      </div>
    </ng-template>
    <!-- COST CENTER SECTION -->
    <ng-template #costCenter>
      @if (isAccountPayment$ | async) {
        <div class="cx-review-summary-card">
          <cx-card [content]="getCostCenterCard(costCenter$ | async) | async"></cx-card>
          <div class="cx-review-summary-edit-step">
            <a
              [routerLink]="
                {
                  cxRoute: getCheckoutStepUrl(steps.SHIPPING_ADDRESS)
                } | cxUrl
              "
              ><cx-icon [type]="iconTypes.PENCIL"></cx-icon
            ></a>
          </div>
        </div>
      }
    </ng-template>
    <!-- SHIPPING ADDRESS SECTION -->
    <ng-template #shippingAddress>
      <div class="cx-review-summary-card cx-review-card-address">
        @if (deliveryAddress$ | async; as deliveryAddress) {
          <cx-card
            [content]="getShippingAddressCard(deliveryAddress, countryName$ | async) | async"
          ></cx-card>
        }
        <div class="cx-review-summary-edit-step">
          <a
            [routerLink]="
              {
                cxRoute: getCheckoutStepUrl(steps.SHIPPING_ADDRESS)
              } | cxUrl
            "
            ><cx-icon [type]="iconTypes.PENCIL"></cx-icon
          ></a>
        </div>
      </div>
    </ng-template>
    <!-- DELIVERY MODE SECTION -->
    <ng-template #deliveryMode>
      <div class="cx-review-summary-card cx-review-card-shipping">
        @if (deliveryMode$ | async; as deliveryMode) {
          <cx-card
            [content]="getDeliveryModeCard(deliveryMode) | async"
          ></cx-card>
        }
        <div class="cx-review-summary-edit-step">
          <a [routerLink]="{ cxRoute: getCheckoutStepUrl(steps.DELIVERY_MODE) } | cxUrl">
            <cx-icon [type]="iconTypes.PENCIL"></cx-icon>
          </a>
        </div>
      </div>
    </ng-template>
    <!-- PAYMENT METHOD SECTION -->
    <ng-template #paymentMethod>
      <div class="cx-review-summary-card cx-review-card-payment">
        <div>
          @if (paymentDetails$ | async; as paymentDetails) {
            <cx-card
              [content]="getPaymentMethodCard(paymentDetails) | async"
            ></cx-card>
          }
        </div>
        <div class="cx-review-summary-edit-step">
          <a [routerLink]="{ cxRoute: getCheckoutStepUrl(steps.PAYMENT_DETAILS) } | cxUrl">
            <cx-icon [type]="iconTypes.PENCIL"></cx-icon>
          </a>
        </div>
      </div>
    </ng-template>
    <!-- CART ITEM SECTION -->
    @if (cart$ | async; as cart) {
      <div class="cx-review-cart-total d-none d-lg-block d-xl-block">
        {{ 'cartItems.cartTotal' | cxTranslate: { count: cart.deliveryItemsQuantity } }}:
        {{ cart.totalPrice?.formattedValue }}
      </div>
      <h4 class="cx-review-cart-heading d-block d-lg-none d-xl-none">
        {{ 'checkoutReview.placeOrder' | cxTranslate }}
      </h4>
      @if (entries$ | async; as entries) {
        <div class="cx-review-cart-item col-md-12">
          <ng-container>
            <cx-promotions [promotions]="entries.promotions"></cx-promotions>
          </ng-container>
          <cx-cart-item-list
            [items]="entries"
            [readonly]="true"
            [promotionLocation]="promotionLocation"
          ></cx-cart-item-list>
        </div>
      }
    }
  }

</div>
